import { useState, useEffect } from 'react';
import { Card, Form, Button, Toast, ToastContainer } from 'react-bootstrap';
import config from '../../config';

function SettingsDisplay({ onSettingsSaved }) {
    const [squareSize, setSquareSize] = useState(60);
    const [pieceFontSize, setPieceFontSize] = useState(45);
    const [timerMinutes, setTimerMinutes] = useState(config.DEFAULT_GAME_SETTINGS.timerMinutes);
    const [selectedPreset, setSelectedPreset] = useState('');
    const [layoutMode, setLayoutMode] = useState('responsive'); 
    // ÚJ: Téma state
    const [theme, setTheme] = useState('green'); 
    
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');

    const presets = {
        s: { squareSize: 40, pieceFontSize: 30 },
        m: { squareSize: 60, pieceFontSize: 45 },
        l: { squareSize: 80, pieceFontSize: 60 },
        xl: { squareSize: 100, pieceFontSize: 75 },
    };

    const showToastMessage = (message) => {
        setToastMessage(message);
        setShowToast(true);
    };

    const handlePresetChange = (value) => {
        if (value === 'responsive') {
            setLayoutMode('responsive');
            setSelectedPreset('responsive');
        } else if (presets[value]) {
            const preset = presets[value];
            setSquareSize(preset.squareSize);
            setPieceFontSize(preset.pieceFontSize);
            setLayoutMode('fixed'); 
            setSelectedPreset(value);
        }
    };

    useEffect(() => {
        const savedSettings = localStorage.getItem('chess-settings');
        if (savedSettings) {
            try {
                const s = JSON.parse(savedSettings);
                setSquareSize(s.squareSize || 60);
                setPieceFontSize(s.pieceFontSize || 45);
                setTimerMinutes(s.timerMinutes || config.DEFAULT_GAME_SETTINGS.timerMinutes);
                setLayoutMode(s.layoutMode || 'responsive');
                // ÚJ: Téma betöltése
                setTheme(s.theme || 'green');

                if (s.layoutMode === 'responsive') setSelectedPreset('responsive');
            } catch (error) {
                console.error('Error loading settings:', error);
            }
        }
    }, []);

    const saveSettings = () => {
        // ÚJ: theme mentése
        const settings = { squareSize, pieceFontSize, layoutMode, timerMinutes, theme };
        localStorage.setItem('chess-settings', JSON.stringify(settings));
        showToastMessage('Settings saved successfully!');
        if (onSettingsSaved) onSettingsSaved();
    };

    return (
        <div className='text-white p-4'>
            <h3 className='text-center mb-4'>Settings</h3>
            <ToastContainer position="bottom-end" className="p-3">
                <Toast show={showToast} onClose={() => setShowToast(false)} delay={3000} autohide bg="success">
                    <Toast.Header><strong className="me-auto">Settings</strong></Toast.Header>
                    <Toast.Body className="text-white">{toastMessage}</Toast.Body>
                </Toast>
            </ToastContainer>
            <Card className="bg-dark-transparent" style={{transform:"none"}}>
                <Card.Body>
                   
                    <Form.Label>Board Theme (High Contrast)</Form.Label>
                    <Form.Select 
                        className='bg-light text-dark mb-3' 
                        onChange={(e) => setTheme(e.target.value)} 
                        value={theme}
                    >
                        <option value="green">Classic Green</option>
                        <option value="highContrast">High Contrast (Black & White)</option>
                        <option value="blue">Blue & Gray</option>
                    </Form.Select>

                    <Form.Label>Board Size / Layout</Form.Label>
                    <Form.Select className='bg-light text-dark mb-3' onChange={(e) => handlePresetChange(e.target.value)} value={selectedPreset}>
                        <option value="" disabled>Select option...</option>
                        <optgroup label="Dynamic"><option value="responsive">Responsive</option></optgroup>
                        <optgroup label="Fixed Sizes">
                            <option value="s">Small</option><option value="m">Medium</option><option value="l">Large</option><option value="xl">Extra Large</option>
                        </optgroup>
                    </Form.Select>
                    <div className="d-grid gap-2 mt-4">
                        <Button className='bg-dark-green text-white' onClick={saveSettings}>Save All Settings</Button>
                    </div>
                </Card.Body>
            </Card>
        </div>
    );
}
export default SettingsDisplay;